export default "__VITE_ASSET__3ba75c48__"